import { AvField } from "availity-reactstrap-validation"
import { useEffect, useState } from "react"
import { Alert, Row, Col } from "reactstrap"

import Licensing from "services/Licensing.service"

const user = JSON.parse(localStorage.getItem("authUser"))
let licensingService = new Licensing(user)

const WasteIdentification = props => {
  const [rows, setrows] = useState()
  const [wasteIdsDefault, setwasteIdsDefault] = useState({})

  useEffect(() => {
    fetchWasteIds()
    fetchClientWasteIds(props.appId)
  }, [])

  useEffect(() => {
    if (props.editMode) {
      fetchWasteIds()
    }
  }, [wasteIdsDefault])

  const fetchWasteIds = () => {
    licensingService.getAllWasteIdentifications().then(response => {
      if (response.status) {
        const myRows = response.data.map((item, index) => {
          return (
            <>
            <br></br>
            <Row key={index}>
              <label htmlFor="" className="col-lg-3 col-form-label">
                {item.name}
              </label>
              <div className="col-lg-9">
                <AvField
                  type="text"
                  name={"wasteid_" + item.id}
                  label=""
                  placeholder={"Enter Code"}
                  value={wasteIdsDefault["wasteid_" + item.id]? wasteIdsDefault["wasteid_" + item.id] : ""}
                />
              </div>
            </Row>
          </>
          )
        })
        setrows(myRows)
      }
    })
  }

  const fetchClientWasteIds = appId => {
    licensingService.getClientWasteIds(appId).then(response => {
      let wastesObj = {}
      if (response.status) {
        response.data.forEach(item => {
          let inputName = "wasteid_" + item.waste_identification.id

          wastesObj[inputName] = item.code
        })
        setwasteIdsDefault(wastesObj)
      }
    })
  }
  return <>{rows}</>
}

export default WasteIdentification
